export const PATH = {
    DOCUMENT_SERVICE: '/user/:id/companies/:companyId/documents',
    GET_POSTS: '/TaxPlanningServices/users/:id/companies/:companyId/posts?from=:from',
    GET_ADVANCED_SEARCH_OPTIONS: ':from&searchKey=:searchKey&advSearch=:advSearch&userSearchText=:userSearchText&doesntHaveSearchText=:doesntHaveSearchText&dateWithinText=:dateWithinText&postsFrom=:postsFrom&postsTo=:postsTo&unReplied=:unReplied&myPosts=:myPosts&unRead=:unRead&label_id=:label_id&deliveryStatus=:deliveryStatus',
    UPDATE_POST: '/TaxPlanningServices/users/:id/companies/:companyId/posts/:postID',
    DOCUMENT_TYPE_SERVICE: '/TaxPlanningServices/user/:id/companies/:companyId/documents',
    GET_DOCUMENT_TYPE_SERVICE: '/TaxPlanningServices/user/:id/documents',
    TAXES_ANSWER_SERVICE : '/TaxPlanningServices/companies/:companyId/questions/:questionId',
    USER_PROFILE_SERVICE : '/TaxPlanningServices/companies/:companyId/taxpayer/:taxpayerId',
    CATEGORIZE_POST : '/TaxPlanningServices/user/:userId/company/:companyId/categorize',
    TASK_SERVICE: '/TaxPlanningServices/users/:id/tasks',
    REMOVE_TASK_SERVICE: '/TaxPlanningServices/users/:userId/tasks/:id',
    CLIENT_TASK_SERVICE: '/TaxPlanningServices/org/:org/users/:id/tasks/list',
    LABELS_SERVICE: '/TaxPlanningServices/labels',
    TASK_HISTORY_SERVICE: '/TaxPlanningServices/taskHistory/:taskId',
    ASSIGNEES_SERVICE: '/TaxPlanningServices/org/:org/users/:id/users/list',
    GET_TEAMS: '/TaxPlanningServices/users/:id/teams',
    REMINDERS: '/TaxPlanningServices/users/:id/reminders',
    WALL_DOCUMENT_SERVICE: '/user/:id/documents',
    ORG_USER_SERVICE: '/TaxPlanningServices/users/:userId/orgs/:org',
    USER_DOCUMENT_TYPE_SERVICE: '/TaxPlanningServices/user/:id/documents',
    USER_DOCUMENT_SERVICE: '/user/:id/documents',
    PDF_SERVICE: '/TaxPlanningServices/report/pdf',
    MAIL_POST: '/TaxPlanningServices/users/:id',
    ADD_NEW_USER_SERVICE: '/TaxPlanningServices/org/:orgId/users/:userId/users',
    ORGS_SERVICES: '/TaxPlanningServices/users/:id/orgs',
    ORGS_DELETE_USER: '/TaxPlanningServices/orgs/:org/users/:userId/deleteuser/:id',
    GET_ORGS: '/TaxPlanningServices/users/:id/orgs',
    ORG_PREFERENCES: '/TaxPlanningServices/orgs/:org/preferences',
    NEW_LABEL_SERVICE: '/TaxPlanningServices/orgs/:org/labels',
    ORG_LOGO_SERVICE: '/TaxPlanningServices/orgs/:org/logos',
    EXPORT_SERVICE: '/TaxPlanningServices/orgs/:orgId/users/:userId/export',
    REMEMBER_ME: '/TaxPlanningServices/rememberMe',
    TASK_TRACKER_SERVICE: '/TaxPlanningServices/users/:id/orgs/:orgId/tracker/:trackerId',
    SINGLE_TASK_TRACKER_SERVICE: '/TaxPlanningServices/org/:orgId/users/:userId/tasks/:taskId',
    ALL_TASK_TRACKER_SERVICE: '/TaxPlanningServices/users/:id/orgs/:orgId/trackers/:trackerId',
    SUB_STATUS_SERVICES: '/TaxPlanningServices/orgs/:orgId',
    ROLL_TRACKER_STATUS_SERVICE: '/TaxPlanningServices/users/:id/orgs/:orgId/tasks/:taskId/status/roll',
    FILES_GET: '/TaxPlanningServices/files',
    FILE_MANAGEMENT_MOVE_DOC_SERVICE: '/TaxPlanningServices/files/move',
    ADD_SINGLEPAGE_TODO: '/TaxPlanningServices/orgs/:org/users/:userId/tasks/:taskId/todo',
    USER_INFO_BY_TOKEN_SERVICE: '/TaxPlanningServices/orgs/:org/user/:userId',
    PARTICIPANT_INFO_SERVICE: '/TaxPlanningServices/orgs/:org/users/:id/userinfo',
    S3_CREDENTIALS: '/filemanagementservice/file-store/credentials',
    USER_INFO_BY_SSO_TOKEN_SERVICE: '/TaxPlanningServices/users/:userId/sso/token/:token',
    LABELS_TYPE_SERVICE: '/TaxPlanningServices/orgs/:org/labels/labelTypes',
    GET_ALL_LABELS: '/TaxPlanningServices/orgs/:org/labels/labelTypes/:type',
    POST_LABELS_SERVICE: '/TaxPlanningServices/orgs/:org/users/:userId/labels',
  CHECKLISTS_SERVICE: '/TaxPlanningServices/users/:userId/task/:taskId/checklist',
  
};

export const TOAST_TYPE = {
    success: 'success',
    error: 'error',
    info: 'info',
    warning: 'warning',
    confirm: 'confirm'
};

export const SOURCE_TYPE = {
    JAVA: 'java',
    NODE: 'node',
    BIG_PAY: 'bigpay',
    DOCUMENT: 'document',
    DOWNLOAD: 'download',
    KNOLLI: 'knolli'
};

export const LOGIN_LOGO_CSS: any = {

};

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

export const ORG_LOGO_CSS: any = {
  ahadandco: [{ style: 'width', value: '15rem' }],
};
